var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "x_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 46,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.103 58.755l-16.97-16.97-16.971 16.97-5.701-5.701 16.97-16.97-16.97-16.971 5.568-5.569L36 30.514l16.97-16.97 5.702 5.701L41.7 36.215l16.97 16.971-5.568 5.569z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36-266.47L341.47 39 36 344.47-269.47 39z"
  }))));
}
export default SvgX;